import { useEffect, useState } from 'react';
import './OfferDetailsDisplay.css'
import { useHistory } from 'react-router-dom';
import { GiCannonShot, GiAncientScrew, GiStoneWheel, GiBlacksmith, GiLargePaintBrush, GiFactory } from 'react-icons/gi';
import { BiWrench, BiMailSend } from 'react-icons/bi';
import { CgArrowsShrinkH } from 'react-icons/cg';
import { RiTeamLine } from 'react-icons/ri';
import { FiPhone } from 'react-icons/fi';
import { BsClockHistory } from 'react-icons/bs';
import { FaBuromobelexperte } from 'react-icons/fa';
import { IoIosCash } from 'react-icons/io';
import { Link } from 'react-router-dom';
import Marker from '../Map/Marker/Marker';
import { Wrapper } from "@googlemaps/react-wrapper";
import { GoogleMap, useMap } from "googlemaps-react-primitives";
import { MdKeyboardArrowUp, MdKeyboardArrowDown, MdArrowLeft } from 'react-icons/md';
import { ref as OffersDisplayStorageRef, getDownloadURL } from 'firebase/storage';
import { storage } from '../../config';
import { increment } from 'firebase/database';
import { useAtom } from 'jotai';
import { getAuth } from "firebase/auth";
import { 
    useDetailedOffer, useModalVersion, useShowPopUpModal, 
    useShowDetailedCard, useAllCompanies, useLoggedUser, 
    useModalInfo, useCompaniesLogosUrls, useDetailed 
} from '../../data/GlobalStates';

const OffersDetailsDisplay = ({ get, db, child, dbRef, set, OfferDetailsRef, setRefresh }) => {

    const history = useHistory();
    const authedUser = getAuth(); 


    // Stany globalne (Jotai)
    const [DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);
    const [ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ModalInfo, setModalInfo] = useAtom(useModalInfo);
    const [ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ShowDetailedCard, setShowDetailedCard] = useAtom(useShowDetailedCard);
    const [AllCompanies, setAllCompanies] = useAtom(useAllCompanies);
    const [LoggedUser, setLoggedUser] = useAtom(useLoggedUser);
    const [CompaniesLogosUrls, setCompaniesLogosUrls] = useAtom(useCompaniesLogosUrls);
    const [detailed, setDetailed] = useAtom(useDetailed);

   // Stany lokalne
    const [DetailedOfferUserLogo, setDetailedOfferUserLogo] = useState('');
    const [ShowCompanyDetails, setShowCompanyDetails] = useState(false);
    const [CompanyDetails, setCompanyDetails] = useState('');
    const [bannerValid, setBannerValid] = useState(false);
    const [mapCenterLat, setMapCenterLat] = useState(detailed?.cityLatit ? Number(detailed.cityLatit) : 51);
    const [mapCenterLong, setMapCenterLong] = useState(detailed?.cityLong ? Number(detailed.cityLong) : 20);
    const [ mapZoomLevel, setmapZoomLevel] = useState(8)


useEffect(() => {
  if (detailed?.cityLatit && detailed?.cityLong) {
    const lat = Number(detailed.cityLatit);
    const lng = Number(detailed.cityLong);

    // sprawdzamy, czy konwersja się powiodła
    if (!isNaN(lat) && !isNaN(lng)) {
      setMapCenterLat(lat);
      setMapCenterLong(lng);
    }
  }
}, [detailed]);

    // --- POPRAWKA: Ładowanie Logo i czyszczenie starego stanu ---
    useEffect(() => {
        let isMounted = true;

        // 1. Natychmiastowe czyszczenie poprzedniego logo
        setDetailedOfferUserLogo('');

        if (detailed && detailed.companyName) {
            if (detailed.CompanyLogo) {
                setDetailedOfferUserLogo(detailed.CompanyLogo);
            } else {
                getDownloadURL(OffersDisplayStorageRef(storage, `CompaniesLogos/${detailed.companyName}`))
                    .then((url) => {
                        if (isMounted) setDetailedOfferUserLogo(url);
                    })
                    .catch(() => {
                        if (isMounted) setDetailedOfferUserLogo('');
                    });
            }
        }

        // 2. Refresh dla wymuszenia przerysowania (jeśli wymagane przez architekturę aplikacji)
        setRefresh(Math.floor(Math.random() * 98));

        return () => { isMounted = false; };
    }, [detailed, CompaniesLogosUrls]);

    // Obsługa bannera firmy
    useEffect(() => {
        setBannerValid(false);
        if (!detailed || !detailed.companyBanner) return;

        const img = new Image();
        img.src = detailed.companyBanner;
        img.onload = () => setBannerValid(true);
        img.onerror = () => setBannerValid(false);
    }, [detailed]);

    // Statystyki kliknięć
    const globalDailyPhoneClicksCounter = async () => {
        const pad = (n) => String(n).padStart(2, '0');
        const date = new Date();
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());

        try {
            const statValue = await get(child(dbRef, `stats/DailyPhoneClicksCounter/${year}/${month}/${day}/clicks`));
            if (statValue.val() === null) {
                set(OfferDetailsRef(db, `stats/DailyPhoneClicksCounter/${year}/${month}/${day}/clicks`), 1);
            } else {
                set(OfferDetailsRef(db, `stats/DailyPhoneClicksCounter/${year}/${month}/${day}/clicks`), increment(1));
            }
        } catch (error) {
            set(OfferDetailsRef(db, `errors/${year}/${month}/${day}/DailyPhoneClicksCounter`), error.message);
        }
    };

    const globalDailyMailsClicksCounter = async () => {
        const pad = (n) => String(n).padStart(2, '0');
        const date = new Date();
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());

        try {
            const statValue = await get(child(dbRef, `stats/DailyMailsClicksCounter/${year}/${month}/${day}/clicks`));
            if (statValue.val() === null) {
                set(OfferDetailsRef(db, `stats/DailyMailsClicksCounter/${year}/${month}/${day}/clicks`), 1);
            } else {
                set(OfferDetailsRef(db, `stats/DailyMailsClicksCounter/${year}/${month}/${day}/clicks`), increment(1));
            }
        } catch (error) {
            set(OfferDetailsRef(db, `errors/${year}/${month}/${day}/DailyMailsClicksCounter`), error.message);
        }
    };

    useEffect(() => {
        if (AllCompanies.length && detailed.companyName) {
            setCompanyDetails(AllCompanies.find(company => company.name === detailed.companyName) || '');
        }
    }, [AllCompanies, detailed.companyName]);

    useEffect(() => {
        const companyDescriptionContainer = document.getElementById('CompanyInfoDescriptionContainer');
        const title = document.getElementById('FirstDetails');
        if (ShowCompanyDetails && companyDescriptionContainer) {
            companyDescriptionContainer.scrollIntoView({ behavior: 'smooth' });
        } else if (!ShowCompanyDetails && title) {
            title.scrollIntoView({ behavior: 'smooth' });
        }
    }, [ShowCompanyDetails]);

    const closeModal = () => {
        setDetailedOffer('');
        setShowCompanyDetails(false);
        setDetailedOfferUserLogo('');
        setBannerValid(false);

        if (history.location.pathname === '/addOffer') return;

        if (history.location.from === 'userPanel') {
            history.push('/userPanel');
        } else if (history.location.from === 'BazaFirm') {
            history.push({ pathname: '/BazaFirm', state: history.location.state });
            setShowDetailedCard(detailed.companyName);
        } else {
            history.push('/');
        }
    };


    const showRoleIcon = () => {
        // Jeśli mamy jakiekolwiek logo (z obiektu lub pobrane), wyświetl je
        const finalLogo = detailed.CompanyLogo || DetailedOfferUserLogo;
        
        if (finalLogo) {
            return <img src={finalLogo} className='DetailedUserRoleLogo' alt="Logo" />;
        }

        // Fallback do ikon branżowych
        const iconProps = { className: 'DetailedOfferRoleLogo' };
        switch (detailed.role) {
            case 'Spawacz': return <GiCannonShot {...iconProps} />;
            case 'Monter': return <BiWrench {...iconProps} />;
            case 'Ślusarz': return <GiAncientScrew {...iconProps} />;
            case 'Szlifierz': return <GiStoneWheel {...iconProps} />;
            case 'Kowal': return <GiBlacksmith {...iconProps} />;
            case 'CNC': return <CgArrowsShrinkH {...iconProps} />;
            case 'Malarz': return <GiLargePaintBrush {...iconProps} />;
            case 'Brygadzista': return <RiTeamLine {...iconProps} />;
            case 'Inżynier': return <CgArrowsShrinkH {...iconProps} />;
            default: return null;
        }
    };

    const displaySalaryType = () => {
        if (!detailed.salaryType) return '';
        const types = { 'Godzinowa': '/h', 'Tygodniowa': '/tyg.', 'Miesięczna': '/mies.' };
        return <p className='SalaryTypeShortCut'>{types[detailed.salaryType] || ''}</p>;
    };

    const openSMSorCallModal = () => {
        setShowPopUpModal(true);
        setModalVersion(29);
        setDetailedOffer(detailed);
        phoneDiscoverCounter();
        globalDailyPhoneClicksCounter();
    };

    const openSendEmailModal = () => {
        setShowPopUpModal(true);
        setModalVersion(31);
        setDetailedOffer(detailed);
        countMailClientsOpens();
        globalDailyMailsClicksCounter();
    };

    const ZoomLevelDisplay = () => {
     
    const map = useMap()

    useEffect(() => {
      if (!map) return
       const handleZoomChanged = () => {
       const currentZoom = map.getZoom()
        setmapZoomLevel(currentZoom)
    }
    map.addListener("zoom_changed", handleZoomChanged);
  }, [map])

  return null
};



    const countMailClientsOpens = async () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        try {
            const statValue = await get(child(dbRef, `stats/mailReveals/${year}/${month}/mailReveals`));
            set(OfferDetailsRef(db, `stats/mailReveals/${year}/${month}/mailReveals`), statValue.val() === null ? 1 : increment(1));
        } catch (error) { console.log(error); }
    };

    const phoneDiscoverCounter = async () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        try {
            const statValue = await get(child(dbRef, `stats/phoneReveals/${year}/${month}/phoneReveals`));
            set(OfferDetailsRef(db, `stats/phoneReveals/${year}/${month}/phoneReveals`), statValue.val() === null ? 1 : increment(1));
        } catch (error) { console.log(error); }
    };

    const saveUnregisterApplyStats = async () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        try {
            const statValue = await get(child(dbRef, `stats/unregisterUserApplyClick/${year}/${month}/clicks`));
            set(OfferDetailsRef(db, `stats/unregisterUserApplyClick/${year}/${month}/clicks`), statValue.val() === null ? 1 : increment(1));
        } catch (error) { console.log(error); }
    };

    const OpenAplicationConfirmation = () => {
        setShowPopUpModal(true);
        setModalVersion(38);
        setModalInfo({ title: 'Aplikacja profilem pracownika' });
    };

    const showApplyButton = () => {
        const isAuth = authedUser.currentUser && LoggedUser.AccountType === 'Private';
        
        if (isAuth) {
            return (
                <div id='CompanyInfoMiniLogoContainer'>
                    {detailed.applyWithSJProfile === 'Tak' && (
                        <p className='ApplyRegisterButtonText' onClick={OpenAplicationConfirmation}>
                            {detailed.externalApplyLink ? "Aplikuj Profilem SteelJobs" : "Aplikuj"}
                        </p>
                    )}
                    {detailed.externalApplyLink && (
                        <a href={detailed.externalApplyLink} className='ApplyRegisterButtonText' target="_blank" rel="noreferrer">
                            {detailed.applyWithSJProfile === 'Tak' ? "Formularz zewnętrzny" : "Aplikuj"}
                        </a>
                    )}
                </div>
            );
        } else if (!authedUser.currentUser && (detailed.applyWithSJProfile === 'Tak' || detailed.externalApplyLink)) {
            return (
                <Link to={'/ZarejestrujSie'} onClick={saveUnregisterApplyStats} id='CompanyInfoMiniLogoContainer'>
                    <p className='ApplyRegisterButtonText'>Aplikuj</p>
                </Link>
            );
        }
        return null;
    };

    return (
        <div id='OfferDetailsDiv'>
            <div id='FirstDetails'
                className={bannerValid ? 'BackGroundWithBanner' : 'defaultBackGround'}
                style={{ '--banner-url': bannerValid ? `url(${detailed.companyBanner})` : 'none' }}>

                <div id='TitleDiv'>
                    {detailed.title && <h2 id={detailed.companyBanner ? 'DetailedOfferTitleBanner' : 'DetailedOfferTitle'}>{detailed.title}</h2>}
                </div>

                {!detailed.companyBanner && showRoleIcon()}

                <div className='BackBtnLogoAndCountryContainer'>
                    <MdArrowLeft className={detailed.companyBanner ? 'BackToMainBtnWithBackGround' : 'BackToMainBtn'} onClick={closeModal} />
                    <div className={detailed.companyBanner ? 'offerDetailsCountryAndTitleContainerBanner' : 'offerDetailsCountryAndTitleContainer'}>
                        <h3 id='CountryTitle'>{detailed.country}</h3>
                        <h3 id='CityName'>{detailed.city}</h3>
                    </div>
                </div>
            </div>

            <div id='DetailsDiv1'>
                <div className='DetailContainer'>
                    <GiFactory id='detailedOfferFactoryLogo' className='DetailedContanerLogos' />
                    <h4 className='DetailContainerText'>Firma: </h4>
                    <h3 className='DetailContainerText'>{detailed.companyName}</h3>
                </div>
                <div className='DetailContainer'>
                    <FaBuromobelexperte id='detailedOfferExperienceLogo' className='DetailedContanerLogos' />
                    <p className='DetailContainerText'>doświadczenie: </p>
                    <p className='DetailContainerText'>{detailed.experience}</p>
                </div>
                <div className='DetailContainer'>
                    <BsClockHistory id='detailedOfferAddDateLogo' className='DetailedContanerLogos' />
                    <p className='DetailContainerText'>dodane: {detailed.addDate ? new Date(detailed.addDate).toLocaleDateString() : ''}</p>
                </div>
                <div className='DetailContainer'>
                    <IoIosCash id='detailedOfferSalaryLogo' className='DetailedContanerLogos' />
                    <h3 className='DetailContainerText'>
                        {!detailed.minSalary && !detailed.maxSalary ? "nie podano" : 
                         `${detailed.minSalary ? `od: ${detailed.minSalary}` : ''} ${detailed.maxSalary ? `do: ${detailed.maxSalary}` : ''} ${detailed.currency || ''}`} 
                        {displaySalaryType()}
                    </h3>
                </div>
            </div>


            <div id='DescriptionContainer'>
                <h2 id='DescriptionTitle'>Szczegóły oferty:</h2>
                <h3 id='Description'><pre id='FormattedText'>{detailed.description}</pre></h3>
            </div>

            <Wrapper apiKey={process.env.REACT_APP_MAPSKEY} options={{streetViewControl:false}}>
                <GoogleMap  className='DetailedOfferMap' center={{lat:mapCenterLat, lng:mapCenterLong}} zoom={mapZoomLevel} mapTypeControl={false} options={{streetViewControl: false, zoomControl:false}}>
                     <Marker
                       position={{ lat: Number(detailed.cityLatit), lng: Number(detailed.cityLong) }}
                       key={detailed.id}
                       offer={detailed}
                       mapZoomLevel={mapZoomLevel}
                      />
                  <ZoomLevelDisplay/>
                 </GoogleMap>
            </Wrapper>

            <div id='ContactDiv'>
                <div className='OfferDetailsContactsContainers' onClick={openSMSorCallModal}>
                    <FiPhone className='OfferDetailsContactIcons' />
                    <button id='OfferDetailPhoneNumber'>Pokaż numer</button>
                </div>
                <div className='OfferDetailsContactsContainers' onClick={openSendEmailModal}>
                    <BiMailSend className='OfferDetailsContactIcons' />
                    <button id='OfferDetailPhoneNumber'>e-mail</button>
                </div>
            </div>

            {CompanyDetails.Description && (
                <div id='CompanyInfoContainer'>
                    <button className='OfferDetailsShowCompanyDetailsBtn' onClick={() => setShowCompanyDetails(!ShowCompanyDetails)}>
                        <p>Informacje o firmie</p>
                        {ShowCompanyDetails ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />}
                    </button>
                </div>
            )}

            {ShowCompanyDetails && CompanyDetails.Description && (
                <div id='CompanyInfoDescriptionContainer'>
                    <p>{CompanyDetails.Description}</p>
                </div>
            )}

            {showApplyButton()}

            <div id='CompanyInfoMiniLogoContainer' onClick={closeModal}>
                <p className='OfferDetailsDisplayMiniLogo'>SteelJobs.pl</p>
            </div>
        </div>
    );
};

export default OffersDetailsDisplay;